import { Text, View } from "@react-pdf/renderer";
import Tag from "../ReactPdfComponents/ReactPdfTag";
import { styles } from "../ReactPdfStyles";

type ReportingProjectDetailSectionTypes = {
	data: Record<string, any>;
};

function ReportingProjectDetailSection({
	data,
}: ReportingProjectDetailSectionTypes) {
	return (
		<View style={[styles.section, styles.tableFontSize]}>
			<Text style={styles.tableHeader}>Project detail</Text>
			<View style={styles.column}>
				<View style={styles.row}>
					<Text style={styles.labelCell}>Company</Text>
					<Text style={styles.valueCell}>{data.operator ?? "—"}</Text>

					<Text style={styles.labelCell}>Operation</Text>
					<Text style={[styles.valueCell, styles.borderRight]}>
						{data.operation_name ?? "—"}
					</Text>
				</View>

				<View style={styles.row}>
					<Text style={styles.labelCell}>Project</Text>
					<View style={styles.valueCell}>
						{data.project_code && <Tag>{data.project_code}</Tag>}
						<Text>{data.project_name ?? "—"}</Text>
					</View>
					<Text style={styles.labelCell}>Location</Text>
					<View style={[styles.valueCell, styles.borderRight]}>
						{data.rig && <Tag>{data.rig}</Tag>}
						<Text>{data.country_name ?? "—"}</Text>
					</View>
				</View>

				<View style={styles.row}>
					<Text style={styles.labelCell}>Project area</Text>
					<Text style={styles.valueCell}>{data.project_area ?? "—"}</Text>
					<Text style={styles.labelCell}>Phase</Text>
					<Text style={[styles.valueCell, styles.borderRight]}>
						{data.phase_name ?? "—"}
					</Text>
				</View>
				<View style={styles.row}>
					<Text style={styles.labelCell}>Asset</Text>
					<Text style={styles.valueCell}>{data.well_name ?? "—"}</Text>
					<Text style={styles.labelCell}>Task</Text>
					<Text style={[styles.valueCell, styles.borderRight]}>
						{data.task_name ?? "—"}
					</Text>
				</View>
			</View>
		</View>
	);
}

export default ReportingProjectDetailSection;
